<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <polizas-s-g-card :item="res"></polizas-s-g-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PolizasSGCard from '@/components/Polizas/SG/PolizasSGCard'

export default {
  name: 'PolizasSGTabs',

  components: {
    PolizasSGCard
  },

  computed: {
    ...mapState('polizasSGModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
